<template>
  <v-dialog v-model="dialog" persistent scrollable max-width="75%">
    <v-card class="px-3 py-0">
      <v-card-title class="pa-0">
        <v-col class="text-right pb-0 pt-1 px-0">
          <v-btn icon dark @click="cleanClose()">
            <v-icon color="primary">mdi-close</v-icon>
          </v-btn>
        </v-col>
        <v-col class="text-center py-0" cols="12">
          <h1 v-show="showError" style="font-size: 26px" class="mb-1 pt-0">Pendências do lote</h1>
          <h1 v-show="showValor" style="font-size: 26px" class="mb-1 pt-0">Valor calculado diferente do informado</h1>
          <h1 v-show="showDetails" style="font-size: 26px" class="mb-1 pt-0">Detalhes do lote</h1>
          <b>Arquivo:</b><p class="mb-0 mt-0">{{items.arq_nome}}</p>
        </v-col>
        <v-row>
          <v-col class="px-10 py-1" cols="12" sm="4" md="3">
            <b class="texts">Número do lote:</b>
            <p class="texts mb-0">{{items.arq_numero_lote}}</p>
          </v-col>

          <v-col class="px-10 py-1" cols="12" sm="4" md="3">
            <b class="texts">Importação:</b>
            <p class="texts mb-0">{{items.upload_dt | formatDate}}</p>
          </v-col>

          <v-col class="px-10 py-1" cols="12" sm="4" md="3">
            <b class="texts">Número de guias:</b>
            <p class="texts mb-0">{{items.arq_qtd_guias}}</p>
          </v-col>

          <v-col class="px-10 py-1" cols="12" sm="4" md="3">
            <b class="texts">Valor informado (R$):</b>
            <p v-if="items.arq_vl_informado == items.arq_vl_calculado" class="texts mb-0">{{ items.arq_vl_informado | formatPrice }}</p>
            <p v-if="items.arq_vl_informado != items.arq_vl_calculado" class="mb-0" style="color:#FC9E0D;font-size:14px">
                <b>{{items.arq_vl_informado | formatPrice}}</b>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }" >
                    <span  style="color:#FC9E0D" v-bind="attrs" v-on="on" class="pa-0">
                      <v-icon x-small class="px-1" color="orange">fa-exclamation-triangle</v-icon>
                    </span>
                  </template>
                  <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF">Valor calculado diferente do informado</span>
                </v-tooltip>
            </p> 
          </v-col>

          <v-col class="px-10 py-2" cols="12" sm="4" md="3">
            <b class="texts">Tipo de guia:</b>
            <p class="texts mb-0">{{items.tipo_guia_descricao}}</p>
          </v-col>

          <v-col class="px-10 py-2" cols="12" sm="4" md="3">
            <b class="texts">Transmissão:</b>
            <p class="texts mb-0">{{items.env_op_dt | formatDate}}</p>
          </v-col>

          <v-col class="px-10 py-2" cols="12" sm="4" md="3">
            <b class="texts">Versão do TISS:</b>
            <p class="texts mb-0">{{items.arq_versao}}</p>
          </v-col>

          <v-col class="px-10 py-2" cols="12" sm="4" md="3">
            <b class="texts">Valor calculado (R$):</b>
            <p class="texts mb-0">{{items.arq_vl_calculado | formatPrice}}</p>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="py-0">
        <ErroLote
          v-show="showError"
          :itemsErro="error"
          :listEnvio="envio"
          :critica="critica"
          :showType="errorType == 1? errorType : type"
          :cleanClose="() => cleanClose()"
          :dadosLote="items"
          :envioAutomatico="parameter"
        />
          <!-- :listLote="criticaLote"
          :listGuia="criticaGuia"  -->
        <CapaLote
            v-show="showDetails"
            :items="items"
            :showUpload="showUpload"
            :parameter="parameter"
            :status="status"
            :getLotes="()=>getLotes()"
            :userData="userData"
        />
      </v-card-text>
      <v-card-actions v-show="!showError">
        <v-col class="text-center py-1" cols="12" sm="12" md="12">
          <v-btn
            color="primary"
            height="30px"
            small
            depressed
            @click="cleanClose()"
          >
            Fechar
          </v-btn>
        </v-col>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex"
import moment from "moment";
moment.locale("pt-BR");
import ErroLote from './LoteErro'
import CapaLote from './LoteCapa'
export default {
  components: {
    ErroLote,
    CapaLote
  },
  data() {
    return {
      showValor: false,
      showTable: false,
      showError: false,
      showDetails: false,
      showUpload: false,
      type: null,
      envio: [],
    };
      // criticaLote: null,
      // criticaGuia: null
  },
  filters: {
    formatDate(date) {
      if (!date) return null
      return moment(date).format("L");
    },
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }
  },
  watch: {
    showValue:{
       deep: true,
        handler(type){
        this.updateData(type)
      }
    }
  },
  mounted() {
    this.updateData(this.showValue)
  },
  methods: {
    ...mapActions({
      getDocument: "documents/getDocument"
    }),
    cleanClose() {
      this.showDetails = false
      this.showError = false
      this.showValor = false
      this.showUpload = false
      this.showTable = false
      this.getLotes()
      this.getDetalhesCronograma()
      this.showClose(false)
    },
    updateData(type){
      if (type == 'info') {
          this.showValor = true
          this.showError = false
          this.showDetails = false
        } 
      if (type == 'erro') {
          this.showError = true
          this.showDetails = false
          this.showValor = false
          this.showUpload = false
        } 
      if (type == 'doc') {
        this.showDetails = true
        this.showValor = false
          this.showError = false
        if(this.parameter.FAT_ENVIO_OPERADORA){
          this.showUpload = false
        } else {
          this.showUpload = this.items.etapa >= 70 && !!this.items.capa_lote_doc_id ? false : true
        }
      }
    }
  },
  props: {
    dialog: Boolean,
    showClose: Function,
    items: Object,
    error: Object,
    critica: Object,
    parameter: Boolean,
    status: String,
    getLotes: Function,
    showValue: String,
    errorType: Number,
    userData: Object,
    getDetalhesCronograma: Function
  },
};
</script>

<style>
</style>